module.exports = __webpack_public_path__ + "cbb0ae7ca042c408a41b92fc4e85c4f1.pdf";